import React, { useEffect, useState } from "react";
import { NavBar, SideBar, Breadcrumb, AddSignature } from "../components";
import { handleOnClickLogout, getAllCards } from "../constants";
import { useNavigate } from "react-router-dom";
import "intro.js/introjs.css";
import introJs from "intro.js";

const CreateSignature = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const navigate = useNavigate();
  const [cards, setCards] = useState(["dummy"]);
  const [loading, setLoading] = useState(false);
  const [breads, setBreads] = useState(["Emails", "New Signature"]);
  const changeBreadCrumbs = (i) => {
    setBreads(breads.slice(0, i + 1));
  };
  useEffect(() => {
    if (breads.length < 2) {
      navigate("/signatures");
    }
  }, [breads]);

  useEffect(() => {
    getAllCards(token, setCards);
  }, []);

  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
        interceptFunc={true}
      />
      <div className="flex flex-row w-full h-full">
        <SideBar active={"email signatures"} interceptFunc={true} />
        <div className="flex flex-col w-full">
          <Breadcrumb breads={breads} changeBreadCrumbs={changeBreadCrumbs} />
          <div className="flex flex-col w-full h-full justify-center items-center">
            <AddSignature />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateSignature;
